import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { MapPin, Sprout } from 'lucide-react';

const ProjectSiteSection = ({ photos }) => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ['start end', 'end start'],
  });
  const bgY = useTransform(scrollYProgress, [0, 1], ['0%', '20%']);

  return (
    <section ref={containerRef} className="py-32 bg-white relative overflow-hidden" data-testid="project-site-section">
      {/* Parallax decorative gradient */}
      <motion.div
        style={{ y: bgY }}
        className="absolute -top-20 right-0 w-[500px] h-[500px] bg-purple-100/40 rounded-full blur-3xl -z-0"
      />

      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-100 text-purple-700 rounded-full text-sm font-semibold mb-6">
            <Sprout className="w-4 h-4" />
            Tapak Projek
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Tanah Wakaf & Lawatan Tapak
          </h2>
          <div className="flex items-center justify-center gap-2 text-purple-600 mb-4">
            <MapPin className="w-5 h-5" />
            <span className="text-lg">Lot 1389, Mukim Telok Panglima Garang, Sijangkang</span>
          </div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Tanah wakaf seluas 5 ekar yang bakal menempatkan Kompleks Darul Ummah, direkodkan melalui lawatan jawatankuasa dan majlis pelancaran projek
          </p>
        </motion.div>

        {/* Photo grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {photos.map((photo, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.6, delay: (index % 3) * 0.1 }}
              whileHover={{ y: -8 }}
              className="group rounded-3xl overflow-hidden shadow-lg border border-purple-100 bg-white"
              data-testid={`project-site-photo-${index}`}
            >
              <div className="overflow-hidden h-60">
                <img
                  src={photo.src}
                  alt={photo.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-2">{photo.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{photo.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectSiteSection;
